import { Button, Icon } from '@mui/material'
import React from 'react'
import { useHistory } from 'react-router-dom'

export default function BackButton(props) {
    const history = useHistory()
    const onBackClick = () => {
        if (history.length > 1) {
            history.goBack();
        }  else {
            history.replace('/dashboard');
        }
    }
    if(history.length < 2){
        return null;
    }
    return (
        <Button className="mb-2" onClick={onBackClick}>
            <Icon>arrow_back</Icon>
        </Button>
    )
}
